import { ReactNode } from "react";
import { useInView } from "react-intersection-observer";
import styles from "./index.module.scss";

export default function EmbedContainer({
  children,
  extraClass,
}: {
  children: ReactNode;
  extraClass?: string;
}): JSX.Element {
  const { ref: inViewRef, inView } = useInView({ triggerOnce: true, threshold: 0, rootMargin: "500px 0px" });
  return (
    <div className={`${styles.embedContainer} ${extraClass === "ad" ? styles.ad : ""}`} ref={inViewRef}>
      {inView && <>{children}</>}
    </div>
  );
}
